var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunctional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8917 15.8332V4.1665C17.8917 2.49984 17.0583 1.6665 15.3917 1.6665H12.0583C10.3917 1.6665 9.55835 2.49984 9.55835 4.1665V15.8332C9.55835 17.4998 10.3917 18.3332 12.0583 18.3332H15.3917C17.0583 18.3332 17.8917 17.4998 17.8917 15.8332Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55835 5H13.725",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55835 15H12.8917",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55835 11.625L13.725 11.6667",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55835 8.3335H12.0583",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57506 1.6665C3.21673 1.6665 2.1084 2.77484 2.1084 4.12484V14.9248C2.1084 15.2998 2.26673 15.8665 2.4584 16.1915L3.14173 17.3248C3.92507 18.6332 5.21673 18.6332 6.00007 17.3248L6.6834 16.1915C6.87507 15.8665 7.0334 15.2998 7.0334 14.9248V4.12484C7.0334 2.77484 5.92506 1.6665 4.57506 1.6665Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0334 5.8335H2.1084",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctional);
export default __webpack_public_path__ + "static/media/Functional.25b3533f7ca63bd6d5afec659d50c79d.svg";
export { ForwardRef as ReactComponent };